import React, { Component } from "react";
import PropTypes from "prop-types";
import findLastIndex from "lodash/findLastIndex";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Item from "announcements/components/item";

export default class Announcements extends Component {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    const { items, onDismiss } = this.props;
    const lastShowingIdx = findLastIndex(items, (i) => i.showing);

    if (items.length === 0) {
      return null;
    }

    return (
      <div className="announcements">
        {items.map((item, idx) => (
          <ReactCSSTransitionGroup
            key={idx}
            transitionName="announcement-transition"
            transitionEnterTimeout={250}
            transitionLeaveTimeout={250}
          >
            {item.showing && (
              <Item
                item={item}
                onDismiss={onDismiss}
                visible={idx === lastShowingIdx}
              />
            )}
          </ReactCSSTransitionGroup>
        ))}
      </div>
    );
  }
}

Announcements.propTypes = {
  items: PropTypes.array.isRequired,
  fetch: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};
